const SECRET_KEY = "myAppSecretKey2026"; // any string, keep it consistent everywhere

// XOR each char of the string against the key (repeating)
const xorCipher = (str, key) => {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(
      str.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    );
  }
  return result;
};

// Base64 that's safe to put in a URL query string
const toUrlSafeBase64 = (str) => {
  return btoa(unescape(encodeURIComponent(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const fromUrlSafeBase64 = (str) => {
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "=";
  return decodeURIComponent(escape(atob(base64)));
};

export const encryptParams = (paramsObj) => {
  const jsonStr = JSON.stringify(paramsObj);
  const xored = xorCipher(jsonStr, SECRET_KEY);
  return toUrlSafeBase64(xored);
};

export const decryptParams = (token) => {
  if (!token) return null;
  try {
    const xored = fromUrlSafeBase64(token);
    const jsonStr = xorCipher(xored, SECRET_KEY); // XOR is symmetric
    return JSON.parse(jsonStr);
  } catch (e) {
    console.error("Failed to decrypt URL params", e);
    return null;
  }
};